import React, { useEffect, useState } from 'react';

const ProjectCarousel = ({ photos, title, onOpen, suspended = false }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [playing, setPlaying] = useState(
    () => !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
  const [hovered, setHovered] = useState(false);
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const handleChange = (event) => setPlaying(!event.matches);
    preference.addEventListener('change', handleChange);
    return () => preference.removeEventListener('change', handleChange);
  }, []);

  useEffect(() => {
    if (!playing || hovered || focused || suspended) return undefined;
    const timer = window.setInterval(() => {
      if (!document.hidden) {
        setActiveIndex((index) => (index + 1) % photos.length);
      }
    }, 3000);
    return () => window.clearInterval(timer);
  }, [playing, hovered, focused, suspended, photos.length]);

  const changePhoto = (event, direction) => {
    event.stopPropagation();
    setActiveIndex((index) => (index + direction + photos.length) % photos.length);
  };

  return (
    <div
      className="project-card__image project-carousel"
      role="region"
      aria-roledescription="carousel"
      aria-label={`${title} photos`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onFocusCapture={() => setFocused(true)}
      onBlurCapture={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) setFocused(false);
      }}
      data-no-page-swipe
    >
      <button
        type="button"
        className="project-carousel__expand"
        aria-label={`Enlarge ${title} photo ${activeIndex + 1}`}
        onClick={(event) => {
          event.stopPropagation();
          onOpen?.(activeIndex);
        }}
      >
        {photos.map((photo, index) => (
        <img
          key={photo.src}
          src={photo.src}
          alt={photo.alt}
          aria-hidden={index !== activeIndex}
          className={`project-carousel__photo${index === activeIndex ? ' is-active' : ''}`}
          style={{ objectPosition: photo.position }}
          loading="lazy"
          decoding="async"
        />
        ))}
        <span className="project-image-expand-cue" aria-hidden="true">⤢</span>
      </button>
      <div className="project-carousel__controls">
        <button type="button" aria-label="Previous photo" onClick={(event) => changePhoto(event, -1)}>
          <span aria-hidden="true">‹</span>
        </button>
        <span className="project-carousel__count" aria-live="off">
          {activeIndex + 1} / {photos.length}
        </span>
        <button
          type="button"
          aria-label={playing ? 'Pause slideshow' : 'Play slideshow'}
          onClick={(event) => {
            event.stopPropagation();
            setPlaying((current) => !current);
          }}
        >
          <span aria-hidden="true">{playing ? 'Ⅱ' : '▶'}</span>
        </button>
        <button type="button" aria-label="Next photo" onClick={(event) => changePhoto(event, 1)}>
          <span aria-hidden="true">›</span>
        </button>
      </div>
    </div>
  );
};

export default ProjectCarousel;
